import { defineStore } from 'pinia'
import { login as loginApi, logout as logoutApi, getProfile, register as registerApi } from '@/api/user'

const TOKEN_KEY = 'al_web_token'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem(TOKEN_KEY) || '',
    profile: null
  }),
  getters: {
    isLogin: (state) => !!state.token
  },
  actions: {
    setToken(token) {
      this.token = token || ''
      if (token) {
        localStorage.setItem(TOKEN_KEY, token)
      } else {
        localStorage.removeItem(TOKEN_KEY)
      }
    },
    async login(form) {
      const res = await loginApi(form)
      this.setToken(res.data.token)
      this.profile = res.data.user
      return res
    },
    async register(form) {
      // 注册后待审核，不发 token
      const res = await registerApi(form)
      return res
    },
    async fetchProfile() {
      const res = await getProfile()
      this.profile = res.data
      return res
    },
    async logout() {
      try {
        if (this.token) {
          await logoutApi()
        }
      } finally {
        this.setToken('')
        this.profile = null
      }
    }
  }
})
